import React, {useState, useEffect} from "react";
import {Link, Outlet, useLocation} from "react-router-dom";
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {Container, Grid, useTheme, useMediaQuery, Box, Drawer, Typography, MenuList, MenuItem} from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import SummarizeIcon from '@mui/icons-material/Summarize';

import MainMenu from "../../core/mainMenu";
import {selectCourses} from "../../../store/course/selectors";
import APP_URLs from "../../../consts/url";
import { SIDE_BAR_WIDTH } from "../../../consts/userInterface";


type Props = {

}

const SUPERVISOR_MENU = [
    {
        title: 'Аттестации',
        icon: SummarizeIcon,
        link: APP_URLs.MAIN,
        //@ts-expect-error
        isActive: (location) => {
            const {pathname} = location;
            return pathname === APP_URLs.ATTESTATION_STATISTIC;
        },
    },
    {
        title: 'Пользователи',
        icon: ManageAccountsIcon,
        link: APP_URLs.ORGANISATION_PROFILES,
        //@ts-expect-error
        isActive: (location) => {
            const {pathname} = location;
            if (pathname === APP_URLs.ORGANISATION_PROFILES) {
                return true;
            }
        },
    },
    {
        title: 'Группы',
        icon: SupervisorAccountIcon,
        link: APP_URLs.GROUPS,
        //@ts-expect-error
        isActive: (location) => {
            const {pathname} = location;
            if (pathname.startsWith(APP_URLs.GROUPS)) {
                return true;
            }
            if (pathname.startsWith(APP_URLs.EDIT_GROUP)) {
                return true;
            }
            return false;
        },
    },
    {
        title: 'Настройки',
        icon: SettingsSuggestIcon,
        link: APP_URLs.ORGANISATION_SETTINGS,
        //@ts-expect-error
        isActive: (location) => {
            const {pathname} = location;
            return pathname.startsWith(APP_URLs.ORGANISATION_SETTINGS);
        },
    },
    {
        title: 'Поддержка',
        icon: SupportAgentIcon,
        link: APP_URLs.SUPPORT,
        //@ts-expect-error
        isActive: (location) => {
            const {pathname} = location;
            return pathname.startsWith(APP_URLs.SUPPORT);
        },
    },
]
const View = ({}: Props) => {
    const theme = useTheme();
    const location = useLocation();
    const {t: translate, i18n: languageCtx} = useTranslation();
    //@ts-expect-error
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));
    //@ts-expect-error
    const isXsScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    return (
        <>
            <MainMenu isSuperVisorMenu/>
            <Box sx={{display: 'flex'}}>
                {!isSmallScreen && (
                    <Drawer
                        sx={{
                            width: `${SIDE_BAR_WIDTH}px`,
                            flexShrink: '0',
                            position: 'relative',
                            top: '50px',
                            '& .MuiDrawer-paper': {
                                width: `${SIDE_BAR_WIDTH}px`,
                                paddingTop: '50px',
                                boxSizing: 'border-box',
                                backgroundColor: 'secondary.light',
                            },
                        }}
                        variant={'permanent'}
                        anchor="left"
                    >
                        <MenuList>
                            {SUPERVISOR_MENU.map(({link, title, icon, isActive}, idx) => (
                                <MenuItem divider={idx !== SUPERVISOR_MENU.length - 1} key={idx} selected={isActive(location)}>
                                    <Box
                                        component={Link}
                                        to={link}
                                        key={title}
                                        sx={{
                                            color: '#fff',
                                            textDecoration: 'none',
                                            display: 'flex',
                                            alignContent: 'center',
                                            pl: 2,
                                        }}
                                    >
                                        <Box component={icon} sx={{mr: 1}}/> {title}
                                    </Box>
                                </MenuItem>
                            ))}
                        </MenuList>
                    </Drawer>
                )}
                <Box component='main' sx={{flexGrow: 1, maxWidth: '100%'}}>
                    <Box sx={{p: 3}}>
                        <Outlet/>
                    </Box>
                    {isSmallScreen && (
                        <MenuList sx={{
                            backgroundColor: 'secondary.light',
                            display: 'grid',
                            gridTemplateColumns: 'repeat(5, 1fr)',
                            position: 'fixed',
                            bottom: 0,
                            right: 0,
                            width: '100vw',

                        }}>
                            {SUPERVISOR_MENU.map(({link, title, icon, isActive}, idx) => (
                                <MenuItem
                                    key={idx}
                                    sx={{
                                        borderRight: idx < SUPERVISOR_MENU.length - 1 ? 'solid 1px rgba(0, 0, 0, 0.12)' : 0,
                                        justifyContent: 'center',
                                    }}
                                    selected={isActive(location)}
                                >
                                    <Box
                                        component={Link}
                                        to={link}
                                        key={title}
                                        sx={{
                                            color: '#fff',
                                            textDecoration: 'none',
                                            display: 'flex',
                                            alignContent: 'center',
                                        }}
                                    >
                                        <Box component={icon} sx={{mr: 1}}/>
                                    </Box>
                                </MenuItem>
                            ))}
                    </MenuList> 
                    )}
                </Box>
            </Box>
        </>
    )
}

//@ts-ignore
const mapStateToProps = (state) => { 
    return {
        courses: selectCourses(state),
    }
}

//@ts-expect-error
const dispatchProps = (dispatch) => ({
})

export default connect(mapStateToProps, dispatchProps)(View);